import client from "../config/api.config";

// Use a function to get the client instead of initializing it at the module level
const getWebClient = () => client.apiClient;

export type PinResetChannel = "EMAIL" | "SMS";

export type PinStatusResponse = { hasPin: boolean; locked: boolean };

export type PinResetRequestResponse = {
  channel: PinResetChannel;
  destinationMasked: string;
};

export function requestCreatePin(pin: string) {
  return getWebClient().request<PinStatusResponse>({
    method: "post",
    url: "/account/pin",
    data: { pin },
    withCredentials: true,
  });
}

export function requestUnlockPin(pin: string) {
  return getWebClient().request<PinStatusResponse>({
    method: "post",
    url: "/account/pin/unlock",
    data: { pin },
    withCredentials: true,
  });
}

export function requestChangePin(currentPin: string, newPin: string) {
  return getWebClient().request<PinStatusResponse>({
    method: "put",
    url: "/account/pin",
    data: { currentPin, newPin },
    withCredentials: true,
  });
}

export function requestPinReset() {
  return getWebClient().request<PinResetRequestResponse>({
    method: "post",
    url: "/account/pin/reset/request",
    withCredentials: true,
  });
}

export function requestConfirmPinReset(otp: string, newPin: string) {
  return getWebClient().request<PinStatusResponse>({
    method: "post",
    url: "/account/pin/reset/confirm",
    data: { otp, newPin },
    withCredentials: true,
  });
}

export type PinLockDelayResponse = { lockMinutes: number };

/** Saves the minutes without activity before the screen locks. */
export function requestUpdatePinLockDelay(lockMinutes: number) {
  return getWebClient().request<PinLockDelayResponse>({
    method: "put",
    url: "/account/pin/lock_delay",
    data: { lockMinutes },
    withCredentials: true,
  });
}

/** Tells the server the user is active (reading, typing): 204. */
export function requestActivityPing() {
  return getWebClient().request<void>({
    method: "post",
    url: "/account/activity",
    withCredentials: true,
  });
}
